import moment from 'moment';
// timeline -> { [key]: value };
export default (
  timelineData: { [key: string]: any[] },
  currentTime: number,
  granularity: 'm' | 's' = 'm',
) => {
  const keys = Object.keys(timelineData);
  const currentMoment = moment(currentTime);
  return keys.reduce((result, key) => {
    const row = timelineData[key].find((data) => {
      const { timeMs, startTimeMs, endTimeMs } = data;
      return (
        (timeMs && currentMoment.isSame(moment(timeMs), granularity)) ||
        (startTimeMs &&
          endTimeMs &&
          currentMoment.isBetween(moment(startTimeMs), moment(endTimeMs), granularity, '[]'))
      );
    });
    if (!row) {
      return result;
    }
    const { value, startValue, endValue } = row;
    if (typeof value === 'object') {
      return { ...result, [key]: value.type || value.name };
    }
    return { ...result, [key]: value || startValue || endValue || 'N/A' };
  }, {});
};
